import { API_BASE_URL, API_PATHS, } from "../constants/api.constants";

export const uploadImage = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE_URL}${API_PATHS.userFileUpload}`, {
    method: "POST",
    body: formData,
    headers: {
      "x-access-token": token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();


  if (data?.data?.location) {
    return data.data.location;
  }

  throw new Error(data.message || "Upload error");
};



export const createocrVerification = async (
  aadhaarFront,
  aadhaarBack,
  token
) => {

  const formData = new FormData();

  formData.append("aadhaarFront", aadhaarFront);

  if (aadhaarBack) {
    formData.append("aadhaarBack", aadhaarBack);
  }

  const response = await fetch(
    `${API_BASE_URL}${API_PATHS.smartocr}`,
    {
      method: "POST",
      body: formData,
      headers: {
        "x-access-token": token,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message || "Verification failed"
    );
  }

  return data;
};